// YERİ: src/app/domains/website/core/public-trial.store.ts
//
// Vitrin: genel ücretsiz deneme teklifi (GET /api/public/trial-offer).
//
// Tek istek, bütün bölümler paylaşır. SSR'da da çekilir; provideClientHydration
// + withHttpTransferCacheOptions sayesinde GET yanıtı sunucudan istemciye
// taşınır, tarayıcı aynı isteği tekrar atmaz ve hidrasyonda ibare aynı çizilir.
// Hata → teklif yok sayılır (ibare görünmez); vitrin asla bu yüzden bozulmaz.

import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';

import { API_BASE } from '@/app/core/auth/auth.service';

export interface PublicTrialOffer {
  available: boolean;
  name?: string | null;
  durationDays: number;
  requireCard: boolean;
}

@Injectable({ providedIn: 'root' })
export class PublicTrialStore {
  private http = inject(HttpClient);
  private started = false;

  /** Null until loaded, or when no public offer exists. */
  readonly offer = signal<PublicTrialOffer | null>(null);

  /** Idempotent: the first caller triggers the request. */
  ensureLoaded(): void {
    if (this.started) return;
    this.started = true;
    this.http.get<{ data: PublicTrialOffer }>(`${API_BASE}/public/trial-offer`).subscribe({
      next: (r) => {
        const d = r?.data;
        this.offer.set(d && d.available && d.durationDays > 0 ? d : null);
      },
      error: () => this.offer.set(null),
    });
  }
}
